import { React, useState, useEffect } from "react";
import { useDispatch } from 'react-redux'
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { Button } from "../../commonComponents/Buttons";
import { TripleGrid } from "../../commonComponents/Grids";

import usersService from "../../../services/userService";
import { get_categories_list } from "../../../redux/features/challengeSlice";

import "./challenges.scss";

function ChallengesCategoriesList() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [categoriesList, setCategoriesList] = useState();
  useEffect(() => {
    
    if (!categoriesList) {
      dispatch(get_categories_list()).then(result => setCategoriesList(result?.payload));
      
    }
  }, [categoriesList, dispatch])

  return (
    <main>
      <Button
        label={t("back")}
        iconClassName="hasIcon--chevron-left"
        viewType="backButton"
        onClick={() => usersService.goToMonolith("dashboard/")}
      />
      <TripleGrid title="Challenges" viewType="wide">
        {categoriesList && categoriesList?.map((item) => {
          return (
            <li key={item?.id}>
              <NavLink
                to={`/challenges-categories/challenges-list/${item?.id}`}
                className="challengeCategoryCard"
              >
                {item?.new_challenge && (
                  <div className="newLabel">{t("newChallenge")}</div>
                )}
                <img
                  className="challengeImage"
                  src={item?.cover_image}
                  alt={t("challenge")}
                />
                <p className="challengeTitle">{item?.title}</p>
              </NavLink>
            </li>
          );
        })}
      </TripleGrid>
    </main>
  );
}

export default ChallengesCategoriesList;
